define(["underscore", "backbone", "backbone.form"], function (_, Backbone) {
  return Backbone.Form.extend({
    url: "/rest_demo_account/validate_demo_additional_account_form",

    validation: {
      demo_member_type_name: {
        required: true,
      },
      currency_abbr: {
        required: true,
      },
      leverage: {
        required: true,
      },
      initial_deposit: {
        required: true,
      },
      mt_version: {
        required: true,
      },
      password: {
        required: true,
      },
      confirm_password: {
        equalTo: "password",
      },
    },

    labels: {
      demo_member_type_name: "Account Type",
      currency_abbr: "Currency Abbr",
      leverage: "Leverage",
      initial_deposit: "Initial Deposit",
      mt_version: "MT Version",
      password: "Password",
      confirm_password: "Confirm Password",
    },
  });
});
